import { render, staticRenderFns } from "./PieEchartsTicket.vue?vue&type=template&id=0f84414e&"
import script from "./PieEchartsTicket.vue?vue&type=script&lang=js&"
export * from "./PieEchartsTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports